<template>
  <van-popup
    v-model="show"
    :overlay="false"
    z-index="2"
    position="bottom"
    :style="{ height: '100vh' }"
    :lock-scroll="false"
  >
    <div class="wrapper">
      <div class="block">
        <div class="button-close" @click="onCloseClick()">
          <img
            style="height: 19px"
            :src="require('../../../assets/imgs/icon/bottom-modal-close.png')"
          />
        </div>

        <div class="content-container">
          <div class="content-title">本文生词</div>
          <div class="content-sub-title">
            文章中任意单词均可点击查看释义并添加至生词本
          </div>
          <div
            class="card-container"
            v-for="item in wordBook"
            :key="item.wordName"
          >
            <div class="new-word-name">{{ item.wordName }}</div>
            <div v-if="item.word" class="new-word-pronunciation">
              <span v-if="item.word.ukPhonetic" style="margin-right: 20px">
                英: {{ item.word.ukPhonetic }}
                <img
                  style="height: 12px"
                  @click="playSound(item.word.ukSpeech)"
                  :src="require('../../../assets/imgs/icon/sound.png')"
                />
              </span>
              <span v-if="item.word.usPhonetic">
                美: {{ item.word.usPhonetic }}
                <img
                  style="height: 12px"
                  @click="playSound(item.word.usSpeech)"
                  :src="require('../../../assets/imgs/icon/sound.png')"
                />
              </span>
              <!-- :src="require('../../../assets/imgs/icon/sound.png')" -->
            </div>

            <div v-if="item.word && item.word.explainCn" class="new-word-cn">
              <div>
                {{ item.word.explainCn }}
              </div>
            </div>
            <div
              v-else-if="item.word && item.word.explains"
              class="new-word-cn"
            >
              <div v-for="explain in item.word.explains" :key="explain">
                {{ explain }}
              </div>
            </div>

            <div v-if="item.sentence" class="new-word-sample-label">文中的句子</div>
            <div v-if="item.sentence" class="new-word-sample">{{ item.sentence.replace(/&nbsp;/g, ' ') }}</div>
          </div>
          <div style="height: 50px; background-color: #fff"></div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import * as ActionTypes from "../../../store/action-types";
import { mapState } from "vuex";

import _ from "lodash";
export default {
  name: "NewWordModal",
  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      show: true,
    };
  },
  computed: {
    ...mapState({
      wordBook: (state) => state.article.wordBook,
      words: (state) => state.article.words,
    }),
  },
  methods: {
    playSound(soundSrc) {
      console.log(soundSrc);
      let audio = new Audio();
      audio.src = soundSrc;
      audio.play();
    },
    onCloseClick() {
      this.onClose();
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: #00000066;
}

.block {
  position: absolute;
  bottom: 0;
  background-color: #fff;
  height: 70vh;
  width: 100%;
  padding-bottom: 50px;
  border-radius: 20px 20px 0 0;
}

.content-container {
  height: 100%;
  padding: 10px 15px;
  text-align: center;
  overflow: auto;
  font-family: serif,SimSun,STSong;
}

.content-title {
  font-size: 18px;
  font-weight: bold;
  font-family: serif,SimSun,STSong;
}

.content-sub-title {
  font-size: 12px;
  line-height: 30px;
  font-family: serif,SimSun,STSong;
  color: #999999;
  transform: scale(0.9);
}

.card-container {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 8px 30px 0px rgba(194, 194, 194, 0.5);
  margin-bottom: 20px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.new-word-name {
  font-size: 18px;
    font-weight :bold
  font-family: serif,SimSun,STSong;
}

.new-word-pronunciation {
  font-size: 12px;
  line-height: 30px;
  font-family: serif,SimSun,STSong;
  color: #999999;
  -webkit-transform-origin-x: 0;
  -webkit-transform: scale(0.9);
  text-align: left;
}

.new-word-cn {
  text-align: left;
}

.new-word-sample-label {
  font-size: 13px;
  font-weight: bold;
  font-family: serif,SimSun,STSong;
  line-height: 50px;
}

.new-word-sample {
  font-size: 12px;
  color: #666666;
  text-align: left;
  font-family: serif,SimSun,STSong;
}

.button-level {
  &-active {
    font-size: 12px;
    color: #ffffff;
    line-height: 28px;
    border-radius: 14px;
    background: linear-gradient(right, #98CEFF, #3994E7);
  }

  &-normal {
    font-size: 12px;
    color: #3994E7;
    line-height: 28px;
    border-radius: 14px;
    border: 1px solid #3994E7;
  }
}

.text-level-desc {
  margin-top: 10px;
  font-size: 12px;
  -webkit-transform-origin-x: 0;
  -webkit-transform: scale(0.9);
  color: #333333;
}

.button-close {
  text-align: center;
  margin: 10px;
}
</style>


// WEBPACK FOOTER //
// app/pages/article/component/NewWordModal.vue